
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog_deprecated",
      function () {
        return require("private-next-pages/blog_deprecated/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog_deprecated"])
      });
    }
  